import React from "react";
import { FlexCenter } from "../../../layout/FlexCenter/FlexCenter";
import { SpacingCustom } from "../../../layout/Spacing/SpacingCustom";
import IconComponent from "../../../shared/IconComponents/IconComponent";
import { Button } from "../../../ui/Button";
import { TextCustom } from "../../../ui/TextCustom";
import { ExecButton } from "../../../ui/ExecButton/ExecButton";

interface IProjectFeatureModalWrapperProps {
    formRef: React.MutableRefObject<HTMLFormElement | null>,
    children?: React.ReactNode,
    error: string,
    iconName: string,
    textLabel: string,
    textAccent?: string,
    hasTextAccent?: boolean,
    func: (e: React.FormEvent<HTMLFormElement>) => void,
    titleSize?: number,
    titleDistance?: number
}

export const ProjectFeatureModalWrapper: React.FC<IProjectFeatureModalWrapperProps>= ({titleDistance = 0, children, titleSize = 1.2,  formRef, error, iconName, textLabel, hasTextAccent = true, textAccent = '', func }) => {
    return (
        <SpacingCustom paddingTop={3}>
            <form ref={formRef} onSubmit={func}>
                <FlexCenter direction="h" position="end" gap={1.5}>
                    <FlexCenter direction="h" position="start" gap={1}>
                        <FlexCenter direction="h" position="start" gap={1}>
                            <SpacingCustom paddingBottom={titleDistance}>
                                <FlexCenter direction="v" position="center" gap={.5}>
                                    <IconComponent iconName={iconName} size={1.6}/>
                                    <TextCustom size={titleSize} color="dark">{textLabel}</TextCustom>
                                    {
                                        hasTextAccent && <TextCustom weight={600} size={1.2} color="dark">{textAccent}</TextCustom>
                                    }
                                </FlexCenter>
                            </SpacingCustom>
                            {children}
                        </FlexCenter>
                        {error && <TextCustom size={1} color="error">{error}</TextCustom>}
                    </FlexCenter>
                    <FlexCenter direction="h" position="end" gap={.5}>
                        {/* <Button btnType="submit" label="Apply" role={"dark"} size={"medium"}/> */}
                        <ExecButton btnType="submit" size="m"  label={"Apply"} iconName={"Apply"}/>
                    </FlexCenter>
                </FlexCenter>
            </form>
        </SpacingCustom>
    )
}